import { useSelector } from "react-redux";
import { useLoader } from "@/hooks/LoaderProvider";
import { useNavigate } from "react-router-dom";
import Button from "@/components/common/Button";
import {
  CheckOutlined,
  ArrowRightOutlined,
  DownloadOutlined,
} from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import { getFirstName } from "@/utils/nameUtils";
import Logo from "@/components/common/Logo";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const userInfo = useSelector((state) => state.accountSetup?.userInfo);
  const userFirstName = getFirstName(userInfo?.fullname);

  const handleProceed = () => {
    showLoader();
    setTimeout(() => {
      hideLoader();
      navigate("/dashboard");
    }, 2000);
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Top section */}
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center logo-container">
          <Logo name="CMSLogo" size="large" />
          <span className="text-[24px] text-primary font-roboto-slab font-normal">
            Veegil
          </span>
        </div>
        <div className="flex items-center">
          <Avatar
            size={32}
            src={userInfo?.profileImage}
            className="mr-2"
            alt={userFirstName || "User"}
          />
          <span className="text-bold text-primary">Hello, {userFirstName}</span>
        </div>
      </div>

      {/* Middle section */}
      <div className="flex flex-col items-center w-full px-4 mt-4 mb-8">
        <div className="flex flex-col items-center w-full max-w-md p-6 rounded-lg bg-lighterBlue">
          <div className="flex flex-col items-center w-full pb-6 mb-6 border-b border-dashed border-primary">
            <div className="p-4 mb-4 rounded-full bg-lightTeal">
              <div className="bg-green rounded-full p-1.5 flex items-center justify-center">
                <CheckOutlined className="text-xs text-white" />
              </div>
            </div>
            <h1 className="text-center text-black poppins-heading-medium">
              Payment Successful!
            </h1>
          </div>

          <div className="w-full p-4 mb-6 rounded-lg">
            <div className="flex justify-between mb-3 text-small">
              <span className="text-darkGrey">Reference Number:</span>
              <span className="text-black poppins-font-medium">
                VGL12345678
              </span>
            </div>
            <div className="flex justify-between mb-3 text-small">
              <span className="text-gray">Date:</span>
              <span className="text-black poppins-font-medium">
                May 15, 2023
              </span>
            </div>
            <div className="flex justify-between mb-3 text-small">
              <span className="text-darkGrey">Time:</span>
              <span className="text-black poppins-font-medium">14:30 PM</span>
            </div>
            <div className="flex justify-between mb-3 text-small">
              <span className="text-darkGrey">Payment Method:</span>
              <span className="text-black poppins-font-medium">
                Credit Card
              </span>
            </div>
            <div className="flex justify-between mt-10 mb-2 text-small">
              <span className="text-darkGrey">Amount:</span>
              <span className="text-black poppins-font-medium">$99.00</span>
            </div>
          </div>

          <div className="w-full my-6 border-t border-dashed border-primary"></div>

          <Button
            text="Get PDF Receipt"
            icon={<DownloadOutlined />}
            onClick={() => {
              /* Handle PDF download */
            }}
            color="primary"
            customBgColor="lighterBlue"
            customTextColor="primary"
            className="flex items-center justify-center w-full mb-4 border text-regular border-primary"
            customTextStyles="ml-2"
            iconPosition="left"
          />
        </div>

        <div className="w-full max-w-md mt-6">
          <Button
            text="Proceed"
            icon={<ArrowRightOutlined />}
            onClick={handleProceed}
            color="primary"
            customBgColor="primary"
            customTextColor="white"
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
